import { ScanLine } from "lucide-react";
import React, { useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import Comprovante from "./Comprovante";
import ConferirSaida from "./ConferirSaida";
import LerQrSaida from "./LerQrSaida";

// Rota `/#/saida/qr/<código>` — o link do QR de saída (dono, 24/09/2026).
// Três partes de propósito: o link impresso de uma mesa é `/#/<nome>/<token>`
// (duas), e uma mesa chamada "Saída" cairia aqui com `/#/saida/<código>`.
// Aberto por quem está logado na loja (a câmera do celular da equipe abre o
// link) → tela de conferir e liberar a saída. Aberto pelo cliente → o
// comprovante dele. O mesmo link serve aos dois: é o que o QR carrega.
export default function SaidaPage({ isAuthenticated }) {
  const { codigo } = useParams();
  const { search } = useLocation();
  const voltar = new URLSearchParams(search).get("voltar");
  const [comoCliente, setComoCliente] = useState(false);
  const [lendo, setLendo] = useState(false);

  if (!isAuthenticated || comoCliente) return <Comprovante codigo={codigo} voltar={voltar} />;

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-md mx-auto px-4 py-5 space-y-3">
        <div className="flex items-center gap-2">
          <h1 className="text-lg font-black">Conferir saída</h1>
          <button type="button" onClick={() => setLendo(true)} data-e2e="saida-ler-outro"
            className="ml-auto h-9 px-3 rounded-full border text-sm font-bold flex items-center gap-1.5">
            <ScanLine className="w-4 h-4" /> Ler outro
          </button>
        </div>
        <ConferirSaida codigo={codigo} />
        <button type="button" onClick={() => setComoCliente(true)} className="w-full text-xs text-muted-foreground underline">
          Ver como o cliente vê
        </button>
      </div>
      <LerQrSaida aberto={lendo} onFechar={() => setLendo(false)} />
    </div>
  );
}
